import { SparklesIcon } from "@heroicons/react/24/outline"
import { classNamesOrEmpty } from "../../style/common"
import { ProductDetailsCard } from "../../models/Product"
import { Price } from "../../models/Price"
import { useEffect, useState } from "react"
import { getTcgPlayerUrl } from "../../functions/Common"
import { RainbowIcon } from "../Icons/RainbowIcon"

export type CardVariantImageProductFooterProps = {
    productDetailsCard: ProductDetailsCard,
    variantPriceDictionary: Record<string, Price>,
    className?: string | undefined
}

export function CardVariantImageProductFooter(props: CardVariantImageProductFooterProps) {
    const [price, setPrice] = useState<Price | undefined>(undefined);

    useEffect(() => {
        if (!props.productDetailsCard || !props.variantPriceDictionary) {
            setPrice(undefined);
            return;
        }

        setPrice(props.variantPriceDictionary[props.productDetailsCard.id]);
    }, [props.productDetailsCard, props.variantPriceDictionary]);

    return (
        <div className={`flex flex-row justify-between mt-2 ${classNamesOrEmpty(props.className)}`}>
            <div className="w-full">
                {
                    <h3 className="text-sm font-semibold">
                        {`${props.productDetailsCard.altSerial ? props.productDetailsCard.altSerial : props.productDetailsCard.serial}${props.productDetailsCard.card.name ? ` - ${props.productDetailsCard.card.name}` : ""}`}
                    </h3>
                }
                <div className="mt-1 text-sm flex justify-between w-full">
                    <span className="flex">
                        {props.productDetailsCard.variant}
                        {
                            props.productDetailsCard.finish === "foil" &&
                            <SparklesIcon className="h-4 w-4 shrink-0 z-10 self-center ml-1" />
                        }
                        {
                            props.productDetailsCard.finish === "rainbow" &&
                            <RainbowIcon classNames={{ svg: "h-4 w-4 shrink-0 z-10 self-center ml-1" }} />
                        }
                    </span>
                </div>

                {
                    !!price &&
                    <a href={getTcgPlayerUrl({ finish: props.productDetailsCard.finish, tcgPlayerId: props.productDetailsCard.tcgPlayerId })} target="_blank" className="text-green-600 text-xs">
                        ${price.price.toFixed(2)}
                    </a>
                }
            </div>

            {
                !!props.productDetailsCard.quantity &&
                <div className="text-gray-400 select-none" style={{ fontWeight: 900, fontSize: "3rem", lineHeight: 1 }} title={`${props.productDetailsCard.quantity} included in this product`}>{props.productDetailsCard.quantity}</div>
            }
        </div>
    )
}